import { render, staticRenderFns } from "./Webhook.vue?vue&type=template&id=38f2519e&scoped=true"
import script from "./Webhook.vue?vue&type=script&lang=js"
export * from "./Webhook.vue?vue&type=script&lang=js"
import style0 from "./Webhook.vue?vue&type=style&index=0&id=38f2519e&prod&lang=scss&scoped=true"
import style1 from "./Webhook.vue?vue&type=style&index=1&id=38f2519e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2519e",
  null
  
)

export default component.exports